const ENDPOINT = "https://hgv-backend.onrender.com";
export default ENDPOINT;
